var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('section',{staticClass:"home section-bg",class:_vm.customClassName},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }